import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Структура «Код бюджетной классификации» */
let PitFinancingItem = class PitFinancingItem {
    constructor(fields) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
    get id() {
        return this._id ? this._id : this._financingItemId;
    }
    set id(value) {
        this._id = value;
    }
    get financingItemId() {
        return this._financingItemId ? this._financingItemId : this._id;
    }
    set financingItemId(value) {
        this._financingItemId = value;
    }
    get kadmId() {
        return this._kadmId;
    }
    set kadmId(value) {
        this._kadmId = value;
    }
    get kfsrId() {
        return this._kfsrId;
    }
    set kfsrId(value) {
        this._kfsrId = value;
    }
    get kcsrId() {
        return this._kcsrId;
    }
    set kcsrId(value) {
        this._kcsrId = value;
    }
    get kvrId() {
        return this._kvrId;
    }
    set kvrId(value) {
        this._kvrId = value;
    }
    get kosguId() {
        return this._kosguId;
    }
    set kosguId(value) {
        this._kosguId = value;
    }
    get dopFkId() {
        return this._dopFkId;
    }
    set dopFkId(value) {
        this._dopFkId = value;
    }
    get dopEkId() {
        return this._dopEkId;
    }
    set dopEkId(value) {
        this._dopEkId = value;
    }
    get dopKrId() {
        return this._dopKrId;
    }
    set dopKrId(value) {
        this._dopKrId = value;
    }
    get budgetLevelId() {
        return this._budgetLevelId;
    }
    set budgetLevelId(value) {
        this._budgetLevelId = value;
    }
    get kadmCode() {
        return this._kadmCode;
    }
    set kadmCode(value) {
        this._kadmCode = value;
    }
    get kfsrCode() {
        return this._kfsrCode;
    }
    set kfsrCode(value) {
        this._kfsrCode = value;
    }
    get kcsrCode() {
        return this._kcsrCode;
    }
    set kcsrCode(value) {
        this._kcsrCode = value;
    }
    get kvrCode() {
        return this._kvrCode;
    }
    set kvrCode(value) {
        this._kvrCode = value;
    }
    get kosguCode() {
        return this._kosguCode;
    }
    set kosguCode(value) {
        this._kosguCode = value;
    }
    get dopFkCode() {
        return this._dopFkCode;
    }
    set dopFkCode(value) {
        this._dopFkCode = value;
    }
    get dopEkCode() {
        return this._dopEkCode;
    }
    set dopEkCode(value) {
        this._dopEkCode = value;
    }
    get dopKrCode() {
        return this._dopKrCode;
    }
    set dopKrCode(value) {
        this._dopKrCode = value;
    }
    get normTypeId() {
        return this._normTypeId;
    }
    set normTypeId(value) {
        this._normTypeId = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "financingItemId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_financingItemId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "budgetLevelId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_budgetLevelId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "normTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_normTypeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kadmId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_kadmId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kadmCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_kadmCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kfsrId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_kfsrId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kfsrCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_kfsrCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kcsrId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_kcsrId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kcsrCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_kcsrCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kvrId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_kvrId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kvrCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_kvrCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kosguId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_kosguId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "kosguCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_kosguCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dopFkId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_dopFkId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dopFkCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_dopFkCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dopEkId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_dopEkId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dopEkCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_dopEkCode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dopKrId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingItem.prototype, "_dopKrId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dopKrCode", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFinancingItem.prototype, "_dopKrCode", void 0);
PitFinancingItem = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitFinancingItem);
export { PitFinancingItem };
